/* eslint-disable quote-props */
export const COUNTRIES = [
  { key: 'brazil', value: 'brazil' },
  { key: 'canada', value: 'canada' },
  { key: 'united-states', value: 'united-states' },
];

export const BRAZIL = [
  { key: 'acre', value: 'Acre' },
  { key: 'alagoas', value: 'Alagoas' },
  { key: 'amapa', value: 'Amapá' },
  { key: 'amazonas', value: 'Amazonas' },
  { key: 'bahia', value: 'Bahia' },
  { key: 'ceara', value: 'Ceará' },
  { key: 'distrito-federal', value: 'Distrito Federal' },
  { key: 'espirito-santo', value: 'Espírito Santo' },
  { key: 'goias', value: 'Goiás' },
  { key: 'maranhao', value: 'Maranhão' },
  { key: 'mato-grosso', value: 'Mato Grosso' },
  { key: 'mato-grosso-do-sul', value: 'Mato Grosso do Sul' },
  { key: 'minas-gerais', value: 'Minas Gerais' },
  { key: 'para', value: 'Pará' },
  { key: 'paraiba', value: 'Paraíba' },
  { key: 'parana', value: 'Paraná' },
  { key: 'pernambuco', value: 'Pernambuco' },
  { key: 'piaui', value: 'Piauí' },
  { key: 'rio-de-janeiro', value: 'Rio de Janeiro' },
  { key: 'rio-grande-do-norte', value: 'Rio Grande do Norte' },
  { key: 'rio-grande-do-sul', value: 'Rio Grande do Sul' },
  { key: 'rondonia', value: 'Rondônia' },
  { key: 'roraima', value: 'Roraima' },
  { key: 'santa-catarina', value: 'Santa Catarina' },
  { key: 'sao-paulo', value: 'São Paulo' },
  { key: 'sergipe', value: 'Sergipe' },
  { key: 'tocantins', value: 'Tocantins' },
];

export const CANADA = [
  { key: 'alberta', value: 'Alberta' },
  { key: 'british-columbia', value: 'British Columbia' },
  { key: 'manitoba', value: 'Manitoba' },
  { key: 'new-brunswick', value: 'New Brunswick' },
  { key: 'newfoundland-and-labrador', value: 'Newfoundland and Labrador' },
  { key: 'northwest-territories', value: 'Northwest Territories' },
  { key: 'nova-scotia', value: 'Nova Scotia' },
  { key: 'nunavut', value: 'Nunavut' },
  { key: 'ontario', value: 'Ontario' },
  { key: 'prince-edward-island', value: 'Prince Edward Island' },
  { key: 'quebec', value: 'Quebec' },
  { key: 'saskatchewan', value: 'Saskatchewan' },
  { key: 'yukon', value: 'Yukon' },
];

export const UNITED_STATES = [
  { key: 'alabama', value: 'Alabama' },
  { key: 'alaska', value: 'Alaska' },
  { key: 'arizona', value: 'Arizona' },
  { key: 'arkansas', value: 'Arkansas' },
  { key: 'california', value: 'California' },
  { key: 'colorado', value: 'Colorado' },
  { key: 'connecticut', value: 'Connecticut' },
  { key: 'delaware', value: 'Delaware' },
  { key: 'florida', value: 'Florida' },
  { key: 'georgia', value: 'Georgia' },
  { key: 'hawaii', value: 'Hawaii' },
  { key: 'idaho', value: 'Idaho' },
  { key: 'illinois', value: 'Illinois' },
  { key: 'indiana', value: 'Indiana' },
  { key: 'iowa', value: 'Iowa' },
  { key: 'kansas', value: 'Kansas' },
  { key: 'kentucky', value: 'Kentucky' },
  { key: 'louisiana', value: 'Louisiana' },
  { key: 'maine', value: 'Maine' },
  { key: 'maryland', value: 'Maryland' },
  { key: 'massachusetts', value: 'Massachusetts' },
  { key: 'michigan', value: 'Michigan' },
  { key: 'minnesota', value: 'Minnesota' },
  { key: 'mississippi', value: 'Mississippi' },
  { key: 'missouri', value: 'Missouri' },
  { key: 'montana', value: 'Montana' },
  { key: 'nebraska', value: 'Nebraska' },
  { key: 'nevada', value: 'Nevada' },
  { key: 'new-hampshire', value: 'New Hampshire' },
  { key: 'new-jersey', value: 'New Jersey' },
  { key: 'new-mexico', value: 'New Mexico' },
  { key: 'new-york', value: 'New York' },
  { key: 'north-carolina', value: 'North Carolina' },
  { key: 'north-dakota', value: 'North Dakota' },
  { key: 'ohio', value: 'Ohio' },
  { key: 'oklahoma', value: 'Oklahoma' },
  { key: 'oregon', value: 'Oregon' },
  { key: 'pennsylvania', value: 'Pennsylvania' },
  { key: 'rhode-island', value: 'Rhode Island' },
  { key: 'south-carolina', value: 'South Carolina' },
  { key: 'south-dakota', value: 'South Dakota' },
  { key: 'tennessee', value: 'Tennessee' },
  { key: 'texas', value: 'Texas' },
  { key: 'utah', value: 'Utah' },
  { key: 'vermont', value: 'Vermont' },
  { key: 'virginia', value: 'Virginia' },
  { key: 'washington', value: 'Washington' },
  { key: 'west-virginia', value: 'West Virginia' },
  { key: 'wisconsin', value: 'Wisconsin' },
  { key: 'wyoming', value: 'Wyoming' },
];

export const BRAZIL_TRANSLATIONS = {
  'acre': 'Acre',
  'alagoas': 'Alagoas',
  'amapa': 'Amapá',
  'amazonas': 'Amazonas',
  'bahia': 'Bahia',
  'ceara': 'Ceará',
  'distrito-federal': 'Distrito Federal',
  'espirito-santo': 'Espírito Santo',
  'goias': 'Goiás',
  'maranhao': 'Maranhão',
  'mato-grosso': 'Mato Grosso',
  'mato-grosso-do-sul': 'Mato Grosso do Sul',
  'minas-gerais': 'Minas Gerais',
  'para': 'Pará',
  'paraiba': 'Paraíba',
  'parana': 'Paraná',
  'pernambuco': 'Pernambuco',
  'piaui': 'Piauí',
  'rio-de-janeiro': 'Rio de Janeiro',
  'rio-grande-do-norte': 'Rio Grande do Norte',
  'rio-grande-do-sul': 'Rio Grande do Sul',
  'rondonia': 'Rondônia',
  'roraima': 'Roraima',
  'santa-catarina': 'Santa Catarina',
  'sao-paulo': 'São Paulo',
  'sergipe': 'Sergipe',
  'tocantins': 'Tocantins',
};

export const CANADA_TRANSLATIONS = {
  'alberta': 'Alberta',
  'british-columbia': 'British Columbia',
  'manitoba': 'Manitoba',
  'new-brunswick': 'New Brunswick',
  'newfoundland-and-labrador': 'Newfoundland and Labrador',
  'northwest-territories': 'Northwest Territories',
  'nova-scotia': 'Nova Scotia',
  'nunavut': 'Nunavut',
  'ontario': 'Ontario',
  'prince-edward-island': 'Prince Edward Island',
  'quebec': 'Quebec',
  'saskatchewan': 'Saskatchewan',
  'yukon': 'Yukon',
};

export const UNITED_STATES_TRANSLATIONS = {
  'alabama': 'Alabama',
  'alaska': 'Alaska',
  'arizona': 'Arizona',
  'arkansas': 'Arkansas',
  'california': 'California',
  'colorado': 'Colorado',
  'connecticut': 'Connecticut',
  'delaware': 'Delaware',
  'florida': 'Florida',
  'georgia': 'Georgia',
  'hawaii': 'Hawaii',
  'idaho': 'Idaho',
  'illinois': 'Illinois',
  'indiana': 'Indiana',
  'iowa': 'Iowa',
  'kansas': 'Kansas',
  'kentucky': 'Kentucky',
  'louisiana': 'Louisiana',
  'maine': 'Maine',
  'maryland': 'Maryland',
  'massachusetts': 'Massachusetts',
  'michigan': 'Michigan',
  'minnesota': 'Minnesota',
  'mississippi': 'Mississippi',
  'missouri': 'Missouri',
  'montana': 'Montana',
  'nebraska': 'Nebraska',
  'nevada': 'Nevada',
  'new-hampshire': 'New Hampshire',
  'new-jersey': 'New Jersey',
  'new-mexico': 'New Mexico',
  'new-york': 'New York',
  'north-carolina': 'North Carolina',
  'north-dakota': 'North Dakota',
  'ohio': 'Ohio',
  'oklahoma': 'Oklahoma',
  'oregon': 'Oregon',
  'pennsylvania': 'Pennsylvania',
  'rhode-island': 'Rhode Island',
  'south-carolina': 'South Carolina',
  'south-dakota': 'South Dakota',
  'tennessee': 'Tennessee',
  'texas': 'Texas',
  'utah': 'Utah',
  'vermont': 'Vermont',
  'virginia': 'Virginia',
  'washington': 'Washington',
  'west-virginia': 'West Virginia',
  'wisconsin': 'Wisconsin',
  'wyoming': 'Wyoming',
};
